import api from './api';

const prefix = 'review';

const reviewsAPI = {
  getReviewConfig(params) {
    return api.get(`${prefix}/config`, { params });
  },
  upsertReviewConfig(payload) {
    return api.post(`${prefix}/config/upsert`, payload);
  },
  deleteReviewConfig(payload) {
    return api.post(`${prefix}/config/delete`, payload);
  },
  getReviewRequests(params) {
    return api.get(`${prefix}/requests`, { params });
  },
};

export default reviewsAPI;
